import { useState } from "react";
import OtpVerification from "./components/otpVerification";
import Login from "./components/login";
import LoginUI from "../../shared/components/loginUI";

const App = () => {
  const [qrCodeSrc, setQrCodeSrc] = useState<string | null>(null);

  return (
    <LoginUI
      title="Login"
      reactElement={
        qrCodeSrc ? (
          <OtpVerification qrCodeSrc={qrCodeSrc} />
        ) : (
          <Login setQrCodeSrc={setQrCodeSrc} />
        )
      }
    />
  );
};

export default App;
